import React, { ComponentProps } from 'react';
import ScrollArea from '../../../components/atoms/ScrollArea/ScrollArea';
import { FavoriteItem } from '../FavoritePagesTypes';
import { SortableContentList } from '../../../_lib/components/SortableContentList';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { AddExternalFavorite } from './AddExternalFavorite';
import { AddExternalFavoriteFormProps } from './AddExternalFavoriteForm';
import { DraggableFavouriteListItem } from './DraggableFavouriteListItem';
import IForm from '../../../types/IForm';

type FavoritedPagesBlockEditViewProps = {
  items: FavoriteItem[];
  addExternalFavorite?: AddExternalFavoriteFormProps['form'];
  updateOrder: IForm
};

function EditView({ items, addExternalFavorite, updateOrder }: FavoritedPagesBlockEditViewProps) {
  return (
    <>
      {addExternalFavorite && <AddExternalFavorite form={addExternalFavorite} />}
      <ScrollArea to={100} bottomOffset={10}>
        <SortableContentList items={items} form={updateOrder}>
          {item => (
            <DraggableFavouriteListItem
              id={item.id}
              key={item.id}
              link={item.content.pageLink}
              removeForm={item.removeForm}
              editForm={item.editForm}
            />
          )}
        </SortableContentList>
      </ScrollArea>
    </>
  );
}

export const FavoritedPagesBlockEditView = asFetchableView(EditView);
export type FavoritedPagesBlockEditView = ComponentProps<typeof FavoritedPagesBlockEditView>;
